import { NAVIGATION_ID_KEY } from '@common/Listing/constants/localStorage';
import { get as getItem, remove as removeItem, set as setItem } from '@helpers/localStorage';

export const getNavigationIdValue = () => getItem(NAVIGATION_ID_KEY);

export const removeNavigationIdValue = () => removeItem(NAVIGATION_ID_KEY);

export const setNavigationIdValue = (event, value) => {
    if (value) {
        const eventType = event ? event.type : null;

        if (eventType === 'contextmenu') {
            const navIdFromLocalStorage = getNavigationIdValue();
            window.temporaryNavigationIdValue = !navIdFromLocalStorage ? '' : navIdFromLocalStorage;
            setItem(NAVIGATION_ID_KEY, value);

            if (typeof window.temporaryNavigationIdValue !== 'undefined') {
                document.addEventListener('click',
                    () => {
                        setItem(NAVIGATION_ID_KEY, window.temporaryNavigationIdValue);
                        delete window.temporaryNavigationIdValue;
                    },
                    { once: true });
            }
        } else {
            setItem(NAVIGATION_ID_KEY, value);
        }
    }
};
